
<template>
  <luma-empty>
    <domain-setup-view :save_button="true"></domain-setup-view>
  </luma-empty>
</template>
<script>
  import DomainSetupView from "@/components/domain/setup_domain/domain-setup-view";
  import LumaEmpty from "@/layout/LumaEmpty";
    export default {
        name: "domain-setup",
        components: {LumaEmpty, DomainSetupView},
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/domain/domain-setup.vue